export default __webpack_public_path__ + "static/media/Snd_LowerGBackdown.85cfc4ca.mp3";